import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { yunDianFlow, yunDianBackend } from '@/mocks/jiuchou-business';

export default function YunDian() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="云店"
            title="把实体经营，变成数字经营"
            subtitle="九畴云铺不是把实体店搬到线上，而是给实体店增加一层数字经营能力。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            <FlowExplorer steps={yunDianFlow} direction="horizontal" accent="accent" dark />
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-12">
            <div className="text-center text-sm font-medium text-foreground-300 mb-5">
              云店长后台
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
              {yunDianBackend.map((b) => (
                <div
                  key={b.name}
                  className="p-4 rounded-lg bg-foreground-900 border border-foreground-700 text-center"
                >
                  <div className="w-10 h-10 mx-auto rounded-lg bg-accent-500/20 flex items-center justify-center">
                    <i className={`${b.icon} text-accent-300 text-lg`}></i>
                  </div>
                  <div className="mt-2 font-heading font-bold text-background-50 text-sm">{b.name}</div>
                  <div className="text-xs text-foreground-400">{b.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}